export default{
   serverUrl: "/af-api"
   //serverUrl: "https://dev.onceac.com/af-api"
   //serverUrl: "http://192.168.3.53/af-service"
   //serverUrl: "http://dev.onceac.com:10010/af-service"
}